import * as React from "react";
import { useId } from "@fluentui/react-components";

export const ToasterContext = React.createContext(null);

export default function ToasterContextProvider({ children }) {
  const toasterId = useId("toaster");
  const ctx = toasterId;

  return <ToasterContext.Provider value={ctx}>{children}</ToasterContext.Provider>;
}
